import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import Fetch from 'isomorphic-fetch'

const initialState = {
	reportsPage: 'Rental',
	on_rent: [],
	reservations: [],
	overdue_total: 0,
	liveHire: {
		liveHires: '',
		totalHires: '',
	},
	liveHireLoaded: false,
	onRentLoaded: false,
	reservationsLoaded: false,
}

const formatXandYArray = (arr, pos) => {
	const { data, dates } = arr[pos]
	return { data, dates }
}

const dataDatesReducer = ({ data, dates }) => {
	return (data === null && dates.length ? [1] : data).reduce(function (combine, v, i) {
		combine.push({ x: dates[i], y: Number(v) })
		return combine
	}, [])
}

export function getReportsData(name) {
	return createAsyncThunk(name, async (url: string) => {
		const fetchedData = await Fetch(url, {
			body: undefined,
			credentials: 'same-origin',
			header: {
				'Content-Type': 'application/json; charset=utf-8',
			},
		}).then(res => res.json())

		return fetchedData
	})
}

export const reportingChartsSlice = createSlice({
	name: 'reportingCharts',
	initialState,
	reducers: {
		reservations(state, action) {
			const resXandY = action.payload.reduce(
				function (combine, v) {
					combine.average.push({ x: v.dt, y: Number(v.average) })
					combine.days.push({ x: v.dt, y: Number(v.days) })
					combine.total.push({ x: v.dt, y: Number(v.total) })
					combine.value.push({ x: v.dt, y: Number(v.value) })
					combine.dt.push(v.dt)
					return combine
				},
				{ dt: [], average: [], days: [], total: [], value: [] }
			)

			state.reservations = action.payload
			state.resXandY = resXandY
			state.reservationsLoaded = true
		},
		reservationsFetching(state, action) {
			state.reservations = action.payload
			state.reservationsLoaded = false
		},
		overdueTotal(state, action) {
			if (action.payload) state.overdue_total = action.payload
		},
		onRentTotal(state, action) {
			if (action.payload) state.on_rent_total = action.payload
		},
		futureReservations(state, action) {
			const futureResXandY = action.payload ? dataDatesReducer(formatXandYArray(action.payload, 0)) : []
			if (action.payload) {
				state.future_reservations = action.payload
				state.futureResXandY = futureResXandY
			}
		},
		onRentSeries(state, action) {
			const onRentSeriesXandY = action.payload ? dataDatesReducer(formatXandYArray(action.payload, 0)) : []
			if (action.payload) {
				state.onRentSeriesXandY = onRentSeriesXandY
				state.on_rent_series = action.payload
			}
		},
		reservationsError(state, action) {
			state.reservationsError = action.payload
		},
		liveHire(state, action) {
			const { live_hire } = action.payload
			let { total, highest } = live_hire
			total = JSON.parse(total)
			highest = JSON.parse(highest)
			state.liveHire = {
				liveHires: total,
				totalHires: highest,
			}
			state.liveHireLoaded = true
		},
		liveHireFetching(state) {
			state.liveHireLoaded = false
		},
		liveHireError(state, action) {
			state.liveHireError = action.payload
		},
		onRent(state, action) {
			const on_rentData = Object.values(action.payload).map(el => el)

			state.on_rent = on_rentData
			state.onRentLoaded = true
		},
		onRentFetching(state) {
			state.onRentLoaded = false
		},
		onRentError(state, action) {
			state.onRentError = action.payload
		},
	},
	extraReducers: builder => {
		builder.addCase('reportingCharts/fetchLiveHireData/fulfilled', (state, action) => {
			state.liveHire = { liveHires: action.payload.total, totalHires: action.payload.highest }
			state.liveHireLoaded = true
		}),
			builder.addCase('reportingCharts/fetchOnRentData/fulfilled', (state, action) => {
				state.on_rent = Object.values(action.payload)
				state.onRentLoaded = true
			}),
			builder.addCase('reportingCharts/fetchReservationsData/fulfilled', (state, action) => {
				const resXandY = action.payload.reduce(
					function (combine, v) {
						combine.average.push({ x: v.dt, y: Number(v.average) })
						combine.days.push({ x: v.dt, y: Number(v.days) })
						combine.total.push({ x: v.dt, y: Number(v.total) })
						combine.value.push({ x: v.dt, y: Number(v.value) })
						combine.dt.push(v.dt)
						return combine
					},
					{ dt: [], average: [], days: [], total: [], value: [] }
				)

				state.reservations = action.payload
				state.resXandY = resXandY
				state.reservationsLoaded = true
			})
	},
})

export const {
	reservations,
	reservationsFetching,
	overdueTotal,
	onRentTotal,
	futureReservations,
	onRentSeries,
	reservationsError,
	liveHire,
	liveHireFetching,
	liveHireError,
	onRent,
	onRentFetching,
	onRentError,
} = reportingChartsSlice.actions
